import firebase from "firebase/app";
import { giftSuperCategoryCollection } from "@/firebase";
import { giftCategoryCollection } from "@/firebase";
import { v4 as uuidv4 } from "uuid";
import { storage } from "@/firebase";

const state = {
  giftSuperCategory: [],
};

const getters = {};

const actions = {
  getGiftSuperCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.mode == "live") {
        giftSuperCategoryCollection
          .where("client", "==", payload.client)
          .where("active", "==", true)
          .orderBy("order", "asc")
          .orderBy("title", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGiftSuperCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else
        giftSuperCategoryCollection
          .where("client", "==", payload.client)
          .orderBy("order", "asc")
          .orderBy("title", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGiftSuperCategory", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
    });
  },
  addGiftSuperCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      if (payload.image !== undefined) {
        let uploadPath = "giftSuperCategory/" + payload.client + "-" + uuidv4();

        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                giftSuperCategoryCollection
                  .add(payload)
                  .then((docRef) => {
                    console.log("Added record.");
                    resolve(
                      commit(
                        "addGiftSuperCategory",
                        Object.assign(payload, { id: docRef.id })
                      )
                    );
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";
        giftSuperCategoryCollection
          .add(payload)
          .then((docRef) => {
            console.log("Added record.");
            resolve(
              commit(
                "addGiftSuperCategory",
                Object.assign(payload, { id: docRef.id })
              )
            );
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }
    });
  },
  removeGiftSuperCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftSuperCategoryCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeGiftSuperCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  beforeDeleteRemoveGiftSuperCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCategoryCollection
        .where("client", "==", payload.client)
        .where("superCategory", "==", payload.superCategory)
        .limit(1)
        .get()
        .then((res) => {
          if (res.empty) {
            console.log("EMPTY");
            resolve(true);
          } else {
            console.log("FULL");
            resolve(false);
          }
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  editGiftSuperCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order); // String => Number

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;
        giftSuperCategoryCollection
          .doc(payload.id)
          .set(payload, { merge: true })
          .then(() => {
            resolve(commit("editGiftSuperCategory", payload));
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = "";
        if (payload.image2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          uploadPath = "giftSuperCategory/" + payload.client + "-" + uuidv4();
          //console.log(uploadPath);
          payload.imageURL = uploadPath;
        } else {
          // edit, prejšnje stanje s sliko (replace v storage)
          uploadPath = payload.imageURL;
        }
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;
                giftSuperCategoryCollection
                  .doc(payload.id)
                  .set(payload, { merge: true })
                  .then(() => {
                    resolve(commit("editGiftSuperCategory", payload));
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      }
    });
  },
  // eslint-disable-next-line
  removeImageLinkFromGiftSuperCategory({ commit }, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      payload.image = ""; payload.imageURL = "";
      giftSuperCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftSuperCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftSuperCategoryBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.active = !payload.active;
      giftSuperCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftSuperCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftSuperCategoryBooleanWhiteText({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.whiteText = !payload.whiteText;
      giftSuperCategoryCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGiftSuperCategory", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getGiftSuperCategory(state, payload) {
    state.giftSuperCategory = payload;
    //console.log(state.giftSuperCategory);
  },
  addGiftSuperCategory(state, payload) {
    state.giftSuperCategory.push(payload);
  },
  removeGiftSuperCategory(state, payload) {
    const index = state.giftSuperCategory.findIndex((item) => item.id == payload);
    state.giftSuperCategory.splice(index, 1);
  },
  editGiftSuperCategory(state, payload) {
    const index = state.giftSuperCategory.findIndex((item) => item.id == payload.id);
    state.giftSuperCategory.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
